import { useShallow } from 'zustand/shallow';
import { useAuthStore } from '../store/auth.store';
import { AuthActionType } from '@linkie/shared';
import { StorageConstants } from '@linkie/shared';
import { useLogout } from '@linkie/shared';
import localforage from 'localforage';
import Cookies from 'js-cookie';

const useAuth = () => {
  const { state, dispatch } = useAuthStore(useShallow((store) => ({ state: store.state, dispatch: store.dispatch })));

  const logoutApi = useLogout({
    mutationConfig: {
      onSuccess: async () => {
        dispatch({ type: AuthActionType.LOGOUT_USER });

        Cookies.remove('user_access_token', { path: '/' });
        Cookies.remove('user_access_token');
        Cookies.remove('nolt_token', { path: '/' });
        Cookies.remove('nolt_token');
        Cookies.remove('pageId', { path: '/' });
        Cookies.remove('pageId');

        localStorage.removeItem(StorageConstants.EMAIL_INVITATION_TEXT);
        localStorage.removeItem(StorageConstants.HAS_CUSTOM_SOCIAL_IMAGE);

        await Promise.all([
          localforage.removeItem(StorageConstants.PLAYGROUND_STORE),
          localforage.removeItem(StorageConstants.IDENTITY),
        ]);

        window.location.replace('/auth/login');
      },
    },
  });

  const logout = () => {
    logoutApi.mutate(undefined);
  };

  return {
    state,
    dispatch,
    logout,
  };
};

export default useAuth;
